const IS_DONE_TYPING_ANIMATION = 'IS_DONE_TYPING_ANIMATION'

export default {
  IS_DONE_TYPING_ANIMATION
}
